import { useState, useRef, useEffect } from 'react'

function Dropdown({ trigger, children, className = '', align = 'right', direction = 'down' }) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const menuStyle = {
    ...(align === 'left' ? { left: 0, right: 'auto' } : {}),
    ...(direction === 'up' ? { bottom: '100%', top: 'auto', marginBottom: '4px' } : {}),
  }

  return (
    <div className={`dropdown ${className}`} ref={dropdownRef}>
      <div onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>
      <div
        className={`dropdown-menu ${isOpen ? 'visible' : ''}`}
        style={menuStyle}
      >
        {children}
      </div>
    </div>
  )
}

function DropdownItem({ children, onClick, danger = false, className = '' }) {
  return (
    <div
      className={`dropdown-item ${danger ? 'danger' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

function DropdownDivider() {
  return <div className="dropdown-divider" />
}

Dropdown.Item = DropdownItem
Dropdown.Divider = DropdownDivider

export default Dropdown
